<template>
    <footer class="footer" v-if="data">
        <div class="inner">
            <div class="cols">
                <div class="col-4-1 text" v-html="data.text_1"></div>
                <div class="col-4-1 text" v-html="data.text_2"></div>
                <nav class="col-4-1 menu">
                    <ul v-if="data.menu_1.length !== 0">
                        <li v-for="(item, index) in data.menu_1" :key="index">
                            <Link :to="item.menu_item.url" v-html="item.menu_item.title.replace('&#8232;', '')">
                            </Link>
                        </li>
                    </ul>
                </nav>
                <nav class="col-4-1 menu">
                    <ul v-if="data.menu_2.length !== 0">
                        <li v-for="(item, index) in data.menu_2" :key="index">
                            <Link :to="item.menu_item.url" v-html="item.menu_item.title.replace('&#8232;', '')">
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="cols">
                <ul class="col-4-1 medias">
                    <li v-if="data.medias.instagram">
                        <a :href="data.medias.instagram" target="_black">
                            <svg-icon name="instagram" />
                        </a>
                    </li>
                    <li v-if="data.medias.facebook">
                        <a :href="data.medias.facebook" target="_black">
                            <svg-icon name="facebook" />
                        </a>
                    </li>
                    <li v-if="data.medias.twitter">
                        <a :href="data.medias.twitter" target="_black">
                            <svg-icon name="twitter" />
                        </a>
                    </li>
                    <li v-if="data.medias.vimeo">
                        <a :href="data.medias.vimeo" target="_black">
                            <svg-icon name="vimeo" />
                        </a>
                    </li>
                    <li v-if="data.medias.youtube">
                        <a :href="data.medias.youtube" target="_black">
                            <svg-icon name="youtube" />
                        </a>
                    </li>
                </ul>
                <div class="col-4-1">
                    <a class="btn" :href="data.medias.newsletter" target="_blank">
                        Newsletter Sign-up
                    </a>
                </div>
                <div class="col-2-1 supporter-logos">
                    <img :src="data.logos.url" />
                </div>
            </div>
            <div class="logo">
                <a href="/wysing/"><svg-icon name="logo" /></a>
            </div>
        </div>
    </footer>
</template>

<script>
import Link from '@/components/ui/Link.vue';


export default {
    name: 'Footer',

    data() {
        return {
            data: false,
            is_show: false,
            is_ok: false,
            email: '',
            errmsg: '',
        }
    },

    components: {
        Link,

    },

    methods: {
    },

    mounted() {
        this.$ajax.get('/footer-options').then(res => {
            this.data = res.data;
            this.$store.state.cookies = res.data.cookies;
        });
    },
}
</script>
<style lang="scss">
.footer {
    background: black;
    margin-top: var(--padding-x2);
    padding-top: var(--padding-x2);
    padding-bottom: var(--padding-x2);
    color: white;
    z-index: 10;

    // @media screen and (max-width: 768px) {
    //     margin-top: var(--padding-x8);
    // }

    a {
        color: white !important;
    }

    img {
        max-width: 100%;
    }

    .cols {
        margin-top: var(--padding-x2);
        margin-bottom: var(--padding-x4);

        &:nth-child(2) {
            align-items: center;
        }
    }

    .medias {
        display: flex;
        align-items: center;

        li {
            padding-right: var(--padding-x2);
        }

        a {
            display: block;
            width: 2.8rem;
            height: 2.8rem;

            svg {
                height: 100%;
                width: 100%;
                fill: white;
            }
        }
    }

    .btn {
        color: white;
        height: 3.4rem;
        padding: 0 2.2rem;
        line-height: 3.4rem;
        border-radius: 2rem;
        border: 1px solid;
        display: inline-block;
    }

    // .menu {
    //     ul {
    //     }
    // }

    .logo {
        display: flex;
        justify-content: center;

        a {
            width: 100%;
        }

        svg {
            width: 80%;
            height: 18rem;
            display: block;
            margin: var(--padding-x4) auto;
        }
    }

    @media screen and (max-width: 768px) {
        .cols:first-child {

            .text:nth-child(1) {
                order: 2;
            }

            .text:nth-child(2) {
                margin-top: var(--padding-x4);
                order: 4;
            }

            .menu:nth-child(3) {
                order: 1;
            }

            .menu:nth-child(4) {
                margin-top: var(--padding-x4);
                order: 3;
            }
        }

        .cols .supporter-logos{
            width: 100%;
            margin-top: var(--padding-x3);
        }

        // .menu {
        //     margin-top: var(--padding-x4);
        // }
    }

}
</style>
